import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/archivo/400.css';
import '@fontsource/archivo/500.css';
import '@fontsource/archivo/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
// Design tokens once at the app root; the tenant theme <style> is injected after them by bootstrapTenant.
import '../../../brand/tokens/tokens.css';
import './styles.css';
import { bootPage } from './boot.tsx';
import { readConfig } from './config.ts';
import { finishAuthReturn } from './auth/authReturn.ts';
import { supabase } from './supabase.ts';
import { bootstrapTenant } from './tenant/tenant.ts';

// Teslyn Cloud is light by default (brand/building-teslyn.md); the public legal pages follow the browser.
document.documentElement.dataset.theme = 'light';

const config = readConfig();
const root = createRoot(document.getElementById('root')!);

// The Teslyn Field return page and the legal pages need no tenant or session (boot.tsx); the portal resolves the
// tenant and paints its theme before the first React render (brand/white-label.md).
void bootPage(window.location, config, {
  supabase,
  bootstrapTenant,
  finishAuthReturn: (sb) => finishAuthReturn(sb),
}).then((page) => {
  root.render(<React.StrictMode>{page}</React.StrictMode>);
});
